import React from 'react';

import StyleClass from './Footer.css';

const footer = () => {
	return (
		<div className={StyleClass.wrapper}>
			<footer>
		        <p>Made by Manisha Basra &copy;2018</p>
		    </footer>
		</div>
	);
}

export default footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js